export default __webpack_public_path__ + "static/media/image-29.ff4e7f8a.png";